<template>
	<div class="success-bg">
		<div class="success">
			<div class="message">
				<p>
					Your submission will be moderated before being displayed in voting
					rounds on our campus digital screens and the OK HiQ website along with
					your chosen display name.
				</p>
				<p>
					Moderation times may vary, allowing for weekends and peak periods.
					Please
					<a
						target="_blank"
						href="https://www.qut.edu.au/about/contact/h/hiq"
						rel="noreferrer noopener"
						>contact HiQ</a
					>
					with any queries or concerns.
				</p>
			</div>
			<StateButtons :exclude="['submit']" invert />
		</div>
	</div>
</template>

<script>
import StateButtons from '@/components/main/StateButtons'

export default {
	name: 'SubmitSuccess',
	components: { StateButtons }
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.success-bg {
	background-color: $white;
	overflow: hidden;
}

.success {
	@include corridor;
	margin-top: 1.5rem;
	margin-bottom: 1.5rem;
}

.message {
	margin-bottom: 1.5rem;
}

@include mq(md) {
	.success {
		margin-top: 3rem;
		margin-bottom: 3rem;
	}

	.message {
		margin-bottom: 3rem;
	}
}
</style>
